// goToTopButtonReducer.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  goToTopButtonVisible: false,
};

const goToTopButtonSlice = createSlice({
  name: 'goToTopButton',
  initialState,
  reducers: {
    setGoToTopButtonVisible(state, action) {
      state.goToTopButtonVisible = action.payload;
    },
    reset4GoToTopButtonVisible() {
      return initialState;
    },
  },
});

export const { setGoToTopButtonVisible, reset4GoToTopButtonVisible } = goToTopButtonSlice.actions;
export default goToTopButtonSlice.reducer;
// const initialState = {
//   goToTopButtonVisible: false,
// };

// export default function goToTopButtonReducer(state = initialState, action) {
//   switch (action.type) {
//     case 'setGoToTopButtonVisible':
//       return {
//         ...state,
//         goToTopButtonVisible: action.payload, // Update the selected book
//       };
//     case 'reset4GoToTopButtonVisible':
//       return initialState;     
//     default:
//       return state;
//   }
// }

// export const setGoToTopButtonVisible = (e) => ({
//   type: 'setGoToTopButtonVisible',
//   payload: e,
// });

// export const reset4GoToTopButtonVisible  = (e) => ({
//   type: 'reset4GoToTopButtonVisible',
//   payload: e,
// });